import { useState } from "react";
import { Outlet } from "react-router";
import SideBar from "./drawer";
import TopBar from "./topbar";
import { Box, useMediaQuery } from "@mui/material";

const Layout = () => {
  const [sidebarCollapse, setSidebarCollapse] = useState(false);
  const isMobile = useMediaQuery("(max-width: 767px)");

  const sidebarToggleCollapse = () => {
    setSidebarCollapse(!sidebarCollapse);
  };

  return (
    <>
      <TopBar sidebarToggleCollapse={sidebarToggleCollapse} sidebarCollapse={sidebarCollapse} />
      <Box
        component="main"
        sx={{
          height: "100%",
          pl: isMobile ? 0 : sidebarCollapse ? "60px" : "276px",
          pt: "72px",
          transition: "all 0.3s ease",
        }}
      >
        <SideBar sidebarToggleCollapse={sidebarToggleCollapse} sidebarCollapse={sidebarCollapse} />
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Box sx={{ p: 3 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
